<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item label="录入开始时间：">
              <el-date-picker style="width:193px;" v-model="form.startTime" value-format="timestamp" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="录入结束时间：">
              <el-date-picker style="width:193px;" v-model="form.endTime" value-format="timestamp" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:`${api}/report`,data:form,callback:_d=>tableData=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button  type="primary"
        v-if="showBtn[5].isShow"
        v-loading.fullscreen.lock="lodaingTime" 
        @click="Filter_export(`${api}/export`,form)" 
        icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          prop="areaName"
          label="行政区划名称"
          align="center">
        </el-table-column>
        <el-table-column  
          align="center" 
          v-for="(items,index) in baseInfo" 
          :key="index" 
          :label="items.key">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in items.value"
            :key="(index+300)"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      form:{},
      tableData:[],
      selectRow:[],
      api:'/user/allAllowance',
      baseInfo:[
        {
        key:'岗位补贴和社会保险补贴',value:[
                          {key:'jobAllowanceCount',value:'岗位补贴人数'},
                          {key:'jobAllowanceFee',value:'岗位补贴金额'},
                          {key:'socialAllowanceCount',value:'社会保险补贴人次'},
                          {key:'socialAllowancePersons',value:'社会保险补贴人数'},
                          {key:'socialAllowanceFee',value:'社会保险补贴金额'},
                        ]
        },
        {
        key:'转移就业交通补助',value:[
                        {key:'trafficAllowanceFee',value:'总人数'},
                        {key:'trafficeAllowanceCount',value:'总金额'},
                      ]
        },
        {
        key:'就业创业服务补贴',value:[
                        {key:'resourceAllowanceCount',value:'总人数'},
                        {key:'resourceAllowanceFee',value:'总金额'},
                      ]
        },
        {
        key:'培训补贴和生活费补贴',value:[
                        {key:'trainingAllowanceCount',value:'总人数'},
                        {key:'trainingAllowanceFee',value:'总金额'},
                        ]
        },
        {
        key:'就业扶贫车间',value:[
                      {key:'workShopCount',value:'车间数量'},
                      {key:'workShopPersons',value:'总人数'},
                      {key:'workShopAllowanceFee',value:'总金额'},
                    ]
        },
        {
        key:'以工代训补贴',value:[
                      {key:'trainingWorkAllowanceCount',value:'总人数'},
                      {key:'trainingWorkAllowanceFee',value:'总金额'},
                    ]
        },
        {
        key:'一次性求职创业补贴',value:[
                        {key:'onceSetupAllowanceCount',value:'总人数'},
                        {key:'onceSetupAllowanceFee',value:'总金额'},
                      ]
        },
        {
        key:'就业扶贫基地',value:[
                      {key:'employmentBaseProvince',value:'省'},
                      {key:'employmentBaseCity',value:'市'},
                      {key:'employmentBaseCounty',value:'县'},
                    ]
        },
        {
        key:'爱心基地',value:[
                    {key:'loveUnitProvince',value:'省'},
                    {key:'loveUnitCity',value:'市'},
                    {key:'loveUnitCounty',value:'县'},
                  ]
        },
      ],        
    }
  },
  created() {
    this.isShowBtn("AllAllowanceReport")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>